import { Info } from 'lucide-react';

/**
 * Shown in place of the bookability panel when a campground is entirely
 * first-come, first-served (no online reservations, so no booked %).
 */
export function FirstComeFirstServedCard() {
  return (
    <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-5">
      <p className="text-xs font-semibold tracking-widest uppercase text-emerald-700">
        First-come, first-served
      </p>
      <p className="mt-3 text-sm text-gray-700">
        This campground can't be reserved online or by phone. Sites are claimed
        in person — arrive early, especially on weekends and holidays.
      </p>
      <p className="mt-3 inline-flex items-start gap-1.5 text-xs text-gray-500">
        <Info className="w-3.5 h-3.5 mt-0.5 flex-shrink-0" />
        We can't track live availability for walk-up sites, so there's no booked
        percentage to show.
      </p>
    </div>
  );
}
